import { Routes } from '@angular/router';
import { MpsGuestGuard, MpsLoggedInGuard } from '../../../mps/mps-guards';
import {HomeComponent} from '../core/components/home/home.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/logout/logout.component';

export const routes: Routes = [
   { 
        path: 'auth',
        children: [
            { path: 'login', component: LoginComponent, canActivate: [MpsGuestGuard]  },
            { path: 'logout', component: LogoutComponent, canActivate: [MpsLoggedInGuard]  },
        ]
    },
    {
        path: 'app',  
        children: [ 
            { path: 'home', component: HomeComponent}
        ]
    },
    {
        path: '' ,
        component: LoginComponent
    }
];
